import React from "react";
import PropTypes from "prop-types";
import {Checkbox, Spin} from "antd";
import {API} from 'aws-amplify';
import {S3Image} from "aws-amplify-react";
import * as Styled from "./styled";

class CustomMapping extends React.Component {
  static propTypes = {
    mappingId: PropTypes.string,
    mapping: PropTypes.object,
    transaction: PropTypes.object,
    onChange: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      selection: {},
      mapping: props.mapping,
      loading: false
    };

    this.mapping = props.mapping && {...props.mapping}
  }

  componentWillMount() {
    if (!this.props.mapping && this.props.mappingId) {
      this.setState({ loading: true});
      API.get('api', `mappings/${this.props.mappingId}`).then(
        resp => {
          this.mapping = {...resp};
          this.setState({
            mapping: resp,
            loading: false
          })
        }
      )
    }
  }

  onCheck = (e, img) => {
    const { checked } = e.target;
    const { selection, mapping } = this.state;
    selection[img] = checked;
    this.setState({ selection });
    const images = Object.keys(selection).filter(id => selection[id]);
    this.props.onChange({
      ...mapping,
      images
    }, this.props.transaction);
  };

  render() {
    const { mapping, selection, loading } = this.state;

    if (loading || !mapping) {
      return <Spin spinning size="small" />
    }

    return (
      <Styled.Container>
        <p>Select images below for this order</p>
        <ul>
          {mapping.images.map(i => {
            const filename = i.split("/")[1];
            return (
              <li key={i} style={{ backgroundColor: selection[i] ? '#ffc' : 'white' }}>
                <S3Image
                  className="img"
                  level="public"
                  imgKey={`resized/${i}`}
                />
                <span>{filename}</span>
                <Checkbox onChange={(e) => this.onCheck(e, i)} />
              </li>
            );
          })}
        </ul>
      </Styled.Container>
    );
  }
}

export default CustomMapping;
